import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  background: rgba(255, 255, 255, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000000000;
`;

const BG = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Loading = styled.div`
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border: 0.9em solid ${({ theme }) => theme.colors.primary};
  border-left: 0.9em solid ${({ theme }) => theme.colors.lightGrey};
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 800ms infinite linear;
  animation: load8 800ms infinite linear;
  border-radius: 50%;
  width: 10em;
  height: 10em;
  ::after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

const PageLoading = ({ overlay = false }) =>
  overlay ? (
    <Overlay>
      <Loading />
    </Overlay>
  ) : (
    <BG>
      <Loading />
    </BG>
  );

export default PageLoading;
